import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { NgbTimepickerConfig, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

import { IInputTimepicker } from './input.timepicker.interface';
import { IErrors } from '../../molecules/input/errors.interface';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref
    useExisting: forwardRef(() => InputTimepickerSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-input-timepicker',
    templateUrl: './input.timepicker.component.html',
    styleUrls: ['./input.timepicker.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR,
        NgbTimepickerConfig
    ]
})

export class InputTimepickerSharedComponent implements OnInit, ControlValueAccessor, OnChanges {
    @Input() timerPicker: IInputTimepicker;
    @Input() errors: Array<IErrors> = [];
    time: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
    loaded = false;
    readonlyInputs = false;
    spinners = true;

    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';

    get value(): any { return this._value; }
    set value(val) {
        for (const property in val) {
            if (val.hasOwnProperty(property) && typeof val[property] === 'string') {
                val[property] = parseInt(val[property], 10);
            }
        }
        this.time = val;
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    constructor(private config: NgbTimepickerConfig) {}

    ngOnChanges(changes: SimpleChanges): void {
        const cal = changes['timerPicker'];
        if (cal && !cal.firstChange) {
            this.setConfiguration();
        }
    }

    ngOnInit(): void {
        this.setConfiguration();
        this.loaded = true;
    }

    writeValue(value: NgbTimeStruct): void {
        this.value = value;
    }

    timeChanged(): void {
        this.value = this.time;
    }

    onChange: any = () => {};
    onTouched: any = () => {};
    registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
    registerOnTouched(fn: () => void): void { this.onTouched = fn; }

    setConfiguration(): void {
        if (this.timerPicker && this.timerPicker.config) {
            Object.assign(this.config, this.timerPicker.config);
            if (typeof this.timerPicker.config.readonlyInputs !== 'undefined') this.readonlyInputs = this.timerPicker.config.readonlyInputs;
            if (typeof this.timerPicker.config.spinners !== 'undefined') this.spinners = this.timerPicker.config.spinners;
        }
    }
}
